<template>
  <div class="header">
    <div class="container">
      <div class="site-branding" @click="nextIndex">
        <svg
          class="top_log"
          version="1.1"
          id="图层_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 140 190"
          style="enable-background: new 0 0 140 190"
          xml:space="preserve"
        >
          <g>
            <linearGradient
              id="SVGID_1_"
              gradientUnits="userSpaceOnUse"
              x1="37.0194"
              y1="64.5165"
              x2="86.305"
              y2="64.5165"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #7b420c" />
              <stop offset="0.12" style="stop-color: #8b4c11" />
              <stop offset="0.26" style="stop-color: #b66913" />
              <stop offset="0.34" style="stop-color: #d48004" />
              <stop offset="0.4" style="stop-color: #f39c00" />
              <stop offset="0.87" style="stop-color: #ffe653" />
              <stop offset="1" style="stop-color: #ffe653" />
            </linearGradient>
            <path
              class="st0"
              d="M61.6,152.9c-9.6,1.1-12.8,1.6-13,2.3l1.3,4h17.3l2.1-7.4C67.6,152.2,65.3,152.5,61.6,152.9 M63.6,139.9
            c-11.4,2.5-18.3,4.2-17.9,6.3l1.9,5.9c-0.1-1.2,4.7-2.1,14.8-3.7c2.8-0.4,5.7-0.9,8.5-1.6l2.7-9.4C70.3,138.4,67,139.2,63.6,139.9
            M66.3,126.5c-15.2,4.2-24.3,7-23.4,10.5l1.8,5.9c-0.4-2.5,6-4.4,19.9-7.8c3.5-0.7,7-1.7,10.4-3l2.7-9.4
            C74.1,124.3,70.2,125.6,66.3,126.5 M67.8,113.4c-17.6,5.5-29,9.5-27.8,14.4l1.9,5.9c-0.8-3.7,6.8-6.6,24.1-11.6
            c4.6-1.2,9-2.8,13.4-4.6l2.8-9.6C78.4,109.9,73.9,111.4,67.8,113.4 M69.3,100.2c-23.5,8-33.7,12.5-32.1,18.4l1.8,5.9
            c-1.2-5.3,8.8-9.2,30.1-16.1c8.3-2.7,12.4-4.5,14.4-5.6l2.8-9.6C81.9,95.8,76.7,97.7,69.3,100.2"
            />

            <linearGradient
              id="SVGID_2_"
              gradientUnits="userSpaceOnUse"
              x1="24.775"
              y1="131.1465"
              x2="88.665"
              y2="131.1465"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #002870" />
              <stop offset="8.000000e-02" style="stop-color: #00357c" />
              <stop offset="0.22" style="stop-color: #00589b" />
              <stop offset="0.41" style="stop-color: #008fcc" />
              <stop offset="0.53" style="stop-color: #00b4ed" />
              <stop offset="1" style="stop-color: #98d5f5" />
            </linearGradient>
            <path
              class="st1"
              d="M70.5,86.6C43.8,96.2,32.2,101.7,34,109l1.9,5.9c-1.6-7,12-12.3,34.5-20.1c10-3.5,14.8-5.8,17.1-7.1l2.8-9.6
            C85.2,81.2,79.2,83.5,70.5,86.6 M72.1,73.5c-29.5,11-43.1,17.8-40.9,26.4l1.9,5.9C31.2,97.9,43.5,92,71.8,81.7
            c11.8-4.3,17.3-7,19.9-8.6l2.8-9.7C88.7,67.1,81.9,69.8,72.1,73.5 M73.6,60.3C40.9,72.9,25.8,80.7,28.3,90.7l1.9,5.9
            c-2.2-9.2,11.5-16.1,43-28.1c13.6-5.1,19.9-8.3,22.8-10.2l2.8-9.8C92.3,53,84.7,56,73.6,60.3 M75.2,47.1
            c-36,14.2-52.6,23-49.8,34.4l1.9,5.9c-2.5-10.6,12.5-18.4,47.3-32c15.4-6,22.5-9.7,25.7-11.8l2.8-9.8C95.7,38.8,87,42.4,75.2,47.1
            M76.8,33.9C43.4,47.3,18.3,58.7,22.5,72.4l1.8,5.9c-2.9-11.9,14.3-21.1,51.4-35.8c17.4-6.9,25.2-11.1,28.7-13.5l2.9-9.9
            C99.3,24.7,89.8,28.7,76.8,33.9 M78.5,20.7C42.3,35.5,15,48,19.6,63.2l1.9,5.9c-3.3-13.3,15.3-23.4,55.5-39.7
            c19.3-7.8,27.9-12.5,31.8-15.1l2.9-9.9C103.6,10,94.4,14.2,78.5,20.7"
            />

            <linearGradient
              id="SVGID_3_"
              gradientUnits="userSpaceOnUse"
              x1="78.225"
              y1="51.1615"
              x2="97.045"
              y2="51.1615"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #f1ae00" />
              <stop offset="0.25" style="stop-color: #e48c00" />
              <stop offset="0.38" style="stop-color: #cd770b" />
              <stop offset="0.45" style="stop-color: #ba6713" />
              <stop offset="0.75" style="stop-color: #834011" />
              <stop offset="0.87" style="stop-color: #62340a" />
              <stop offset="1" style="stop-color: #492f0d" />
              <stop offset="1" style="stop-color: #53260b" />
            </linearGradient>
            <path
              class="st2"
              d="M78.2,138c8.5,2.4,15.9,4.6,18.1,6.9l0.7-2.6c-2-2.8-9.4-5.4-17.8-8L78.2,138z"
            />

            <linearGradient
              id="SVGID_4_"
              gradientUnits="userSpaceOnUse"
              x1="76.715"
              y1="46.7565"
              x2="95.925"
              y2="46.7565"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #f1ae00" />
              <stop offset="0.25" style="stop-color: #e48c00" />
              <stop offset="0.38" style="stop-color: #cd770b" />
              <stop offset="0.45" style="stop-color: #ba6713" />
              <stop offset="0.75" style="stop-color: #834011" />
              <stop offset="0.87" style="stop-color: #62340a" />
              <stop offset="1" style="stop-color: #492f0d" />
              <stop offset="1" style="stop-color: #53260b" />
            </linearGradient>
            <path
              class="st3"
              d="M76.7,143.2c8.5,2,16.2,3.7,18.5,5.6l0.7-2.6c-2.2-2.5-9.7-4.8-18.1-7L76.7,143.2z"
            />

            <linearGradient
              id="SVGID_5_"
              gradientUnits="userSpaceOnUse"
              x1="75.245"
              y1="42.1015"
              x2="94.785"
              y2="42.1015"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #f1ae00" />
              <stop offset="0.25" style="stop-color: #e48c00" />
              <stop offset="0.38" style="stop-color: #cd770b" />
              <stop offset="0.45" style="stop-color: #ba6713" />
              <stop offset="0.75" style="stop-color: #834011" />
              <stop offset="0.87" style="stop-color: #62340a" />
              <stop offset="1" style="stop-color: #492f0d" />
              <stop offset="1" style="stop-color: #53260b" />
            </linearGradient>
            <path
              class="st4"
              d="M75.2,148.3c8.4,1.5,16.4,2.9,18.8,4.4l0.7-2.6c-2.3-1.9-10.1-3.8-18.5-5.6L75.2,148.3z"
            />

            <linearGradient
              id="SVGID_6_"
              gradientUnits="userSpaceOnUse"
              x1="73.695"
              y1="37.4865"
              x2="93.655"
              y2="37.4865"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #f1ae00" />
              <stop offset="0.25" style="stop-color: #e48c00" />
              <stop offset="0.38" style="stop-color: #cd770b" />
              <stop offset="0.45" style="stop-color: #ba6713" />
              <stop offset="0.75" style="stop-color: #834011" />
              <stop offset="0.87" style="stop-color: #62340a" />
              <stop offset="1" style="stop-color: #492f0d" />
              <stop offset="1" style="stop-color: #53260b" />
            </linearGradient>
            <path
              class="st5"
              d="M73.7,153.7c8.3,1.1,16.6,2,19.2,3l0.8-2.6c-2.5-1.5-10.6-2.9-18.9-4.2L73.7,153.7z"
            />

            <linearGradient
              id="SVGID_7_"
              gradientUnits="userSpaceOnUse"
              x1="84.195"
              y1="68.7515"
              x2="101.495"
              y2="68.7515"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #f1ae00" />
              <stop offset="0.25" style="stop-color: #e48c00" />
              <stop offset="0.38" style="stop-color: #cd770b" />
              <stop offset="0.45" style="stop-color: #ba6713" />
              <stop offset="0.75" style="stop-color: #834011" />
              <stop offset="0.87" style="stop-color: #62340a" />
              <stop offset="1" style="stop-color: #492f0d" />
              <stop offset="1" style="stop-color: #53260b" />
            </linearGradient>
            <path
              class="st6"
              d="M84.2,117.3c8.3,3.9,14.8,7.8,16.6,12.1l0.7-2.5c-1.7-4.1-8.1-8.1-16.5-12.2L84.2,117.3z"
            />

            <linearGradient
              id="SVGID_8_"
              gradientUnits="userSpaceOnUse"
              x1="82.765"
              y1="64.5865"
              x2="100.395"
              y2="64.5865"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #f1ae00" />
              <stop offset="0.25" style="stop-color: #e48c00" />
              <stop offset="0.38" style="stop-color: #cd770b" />
              <stop offset="0.45" style="stop-color: #ba6713" />
              <stop offset="0.75" style="stop-color: #834011" />
              <stop offset="0.87" style="stop-color: #62340a" />
              <stop offset="1" style="stop-color: #492f0d" />
              <stop offset="1" style="stop-color: #53260b" />
            </linearGradient>
            <path
              class="st7"
              d="M82.8,122.3c8.3,3.5,15,7.1,16.9,11l0.7-2.5c-1.8-4.1-8.4-7.9-16.7-11.7L82.8,122.3z"
            />

            <linearGradient
              id="SVGID_9_"
              gradientUnits="userSpaceOnUse"
              x1="79.825"
              y1="55.7065"
              x2="98.175"
              y2="55.7065"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #f1ae00" />
              <stop offset="0.25" style="stop-color: #e48c00" />
              <stop offset="0.38" style="stop-color: #cd770b" />
              <stop offset="0.45" style="stop-color: #ba6713" />
              <stop offset="0.75" style="stop-color: #834011" />
              <stop offset="0.87" style="stop-color: #62340a" />
              <stop offset="1" style="stop-color: #492f0d" />
              <stop offset="1" style="stop-color: #53260b" />
            </linearGradient>
            <path
              class="st8"
              d="M79.8,132.4c8.4,2.8,15.6,5.5,17.6,8.5l0.7-2.5c-2-3.2-9-6.2-17.4-9.3L79.8,132.4z"
            />

            <linearGradient
              id="SVGID_10_"
              gradientUnits="userSpaceOnUse"
              x1="81.305"
              y1="60.1915"
              x2="99.275"
              y2="60.1915"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #f1ae00" />
              <stop offset="0.25" style="stop-color: #e48c00" />
              <stop offset="0.38" style="stop-color: #cd770b" />
              <stop offset="0.45" style="stop-color: #ba6713" />
              <stop offset="0.75" style="stop-color: #834011" />
              <stop offset="0.87" style="stop-color: #62340a" />
              <stop offset="1" style="stop-color: #492f0d" />
              <stop offset="1" style="stop-color: #53260b" />
            </linearGradient>
            <path
              class="st9"
              d="M81.3,127.3c8.4,3.2,15.3,6.3,17.3,9.8l0.7-2.5c-1.8-3.7-8.7-7.1-17-10.5L81.3,127.3z"
            />

            <linearGradient
              id="SVGID_11_"
              gradientUnits="userSpaceOnUse"
              x1="72.075"
              y1="33.3565"
              x2="92.505"
              y2="33.3565"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #f1ae00" />
              <stop offset="0.25" style="stop-color: #e48c00" />
              <stop offset="0.38" style="stop-color: #cd770b" />
              <stop offset="0.45" style="stop-color: #ba6713" />
              <stop offset="0.75" style="stop-color: #834011" />
              <stop offset="0.87" style="stop-color: #62340a" />
              <stop offset="1" style="stop-color: #492f0d" />
              <stop offset="1" style="stop-color: #53260b" />
            </linearGradient>
            <path
              class="st10"
              d="M72.1,159.3h20.1l0.3-1.2c-2.6-0.9-11.2-1.7-19.3-2.6L72.1,159.3z"
            />

            <linearGradient
              id="SVGID_12_"
              gradientUnits="userSpaceOnUse"
              x1="14"
              y1="17.8865"
              x2="14"
              y2="5.3065"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #0068bb" />
              <stop offset="0.14" style="stop-color: #006dbe" />
              <stop offset="0.3" style="stop-color: #007cc8" />
              <stop offset="0.47" style="stop-color: #0094d8" />
              <stop offset="0.64" style="stop-color: #00b4ed" />
              <stop offset="1" style="stop-color: #6fc2f5" />
            </linearGradient>
            <path
              class="st11"
              d="M11.6,175.1h2.7c1.3,0,2.1,0.7,2.1,1.7s-0.8,1.7-2.1,1.7h-2.7V175.1z M8.7,172.9v12.6h2.9v-4.7h2.8
            c3,0,4.8-1.8,4.8-3.9s-1.8-3.9-4.8-3.9L8.7,172.9z"
            />

            <linearGradient
              id="SVGID_13_"
              gradientUnits="userSpaceOnUse"
              x1="26.535"
              y1="17.8865"
              x2="26.535"
              y2="5.3065"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #0068bb" />
              <stop offset="0.14" style="stop-color: #006dbe" />
              <stop offset="0.3" style="stop-color: #007cc8" />
              <stop offset="0.47" style="stop-color: #0094d8" />
              <stop offset="0.64" style="stop-color: #00b4ed" />
              <stop offset="1" style="stop-color: #6fc2f5" />
            </linearGradient>
            <polygon
              class="st12"
              points="21.7,172.9 21.7,185.5 31.4,185.5 31.4,183.3 24.6,183.3 24.6,180.2 31.4,180.2 31.4,178 24.6,178 
            24.6,175.1 31.4,175.1 31.4,172.9 	"
            />

            <linearGradient
              id="SVGID_14_"
              gradientUnits="userSpaceOnUse"
              x1="39.05"
              y1="17.8865"
              x2="39.05"
              y2="5.3065"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #0068bb" />
              <stop offset="0.14" style="stop-color: #006dbe" />
              <stop offset="0.3" style="stop-color: #007cc8" />
              <stop offset="0.47" style="stop-color: #0094d8" />
              <stop offset="0.64" style="stop-color: #00b4ed" />
              <stop offset="1" style="stop-color: #6fc2f5" />
            </linearGradient>
            <path
              class="st13"
              d="M39.1,176.6l1.8,4.6h-3.6L39.1,176.6z M37.9,172.9l-5.3,12.6h3l0.9-2.2h5.2l0.9,2.2h3l-5.4-12.6H37.9z"
            />

            <linearGradient
              id="SVGID_15_"
              gradientUnits="userSpaceOnUse"
              x1="52.9"
              y1="17.8865"
              x2="52.9"
              y2="5.3065"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #0068bb" />
              <stop offset="0.14" style="stop-color: #006dbe" />
              <stop offset="0.3" style="stop-color: #007cc8" />
              <stop offset="0.47" style="stop-color: #0094d8" />
              <stop offset="0.64" style="stop-color: #00b4ed" />
              <stop offset="1" style="stop-color: #6fc2f5" />
            </linearGradient>
            <path
              class="st14"
              d="M50.2,175.1h2.7c1.3,0,2.1,0.7,2.1,1.7s-0.8,1.7-2.1,1.7h-2.7V175.1z M47.3,172.9v12.6h2.9v-5h2.1l2.9,5h3.3
            l-3.3-5.4c1.5-0.4,2.6-1.7,2.7-3.3c0-2.1-1.8-3.9-4.8-3.9H47.3z"
            />

            <linearGradient
              id="SVGID_16_"
              gradientUnits="userSpaceOnUse"
              x1="65.615"
              y1="17.8865"
              x2="65.615"
              y2="5.3065"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #0068bb" />
              <stop offset="0.14" style="stop-color: #006dbe" />
              <stop offset="0.3" style="stop-color: #007cc8" />
              <stop offset="0.47" style="stop-color: #0094d8" />
              <stop offset="0.64" style="stop-color: #00b4ed" />
              <stop offset="1" style="stop-color: #6fc2f5" />
            </linearGradient>
            <polygon
              class="st15"
              points="60.8,172.9 60.8,185.5 70.4,185.5 70.4,183.3 63.7,183.3 63.7,172.9 	"
            />

            <linearGradient
              id="SVGID_17_"
              gradientUnits="userSpaceOnUse"
              x1="83.07"
              y1="17.8865"
              x2="83.07"
              y2="5.3065"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #0068bb" />
              <stop offset="0.14" style="stop-color: #006dbe" />
              <stop offset="0.3" style="stop-color: #007cc8" />
              <stop offset="0.47" style="stop-color: #0094d8" />
              <stop offset="0.64" style="stop-color: #00b4ed" />
              <stop offset="1" style="stop-color: #6fc2f5" />
            </linearGradient>
            <path
              class="st16"
              d="M80.4,175.1h2.7c1.3,0,2.1,0.7,2.1,1.7s-0.8,1.7-2.1,1.7h-2.7V175.1z M77.5,172.9v12.6h2.9v-5h2.1l2.9,5h3.3
            l-3.3-5.4c1.5-0.4,2.6-1.7,2.7-3.3c0-2.1-1.8-3.9-4.8-3.9H77.5z"
            />

            <linearGradient
              id="SVGID_18_"
              gradientUnits="userSpaceOnUse"
              x1="-8295.3525"
              y1="520.3867"
              x2="-8292.6221"
              y2="520.3867"
              gradientTransform="matrix(0 12.02 -12.02 0 6347.4888 99870.2344)"
            >
              <stop offset="0" style="stop-color: #0068bb" />
              <stop offset="0.34" style="stop-color: #0068bb" />
              <stop offset="0.4" style="stop-color: #006dbf" />
              <stop offset="0.48" style="stop-color: #007dc9" />
              <stop offset="0.56" style="stop-color: #0096d9" />
              <stop offset="0.64" style="stop-color: #00b4ed" />
              <stop offset="1" style="stop-color: #6fc2f5" />
            </linearGradient>
            <rect x="91" y="172.9" class="st17" width="2.9" height="12.6" />

            <linearGradient
              id="SVGID_19_"
              gradientUnits="userSpaceOnUse"
              x1="101.585"
              y1="17.8865"
              x2="101.585"
              y2="5.3065"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #0068bb" />
              <stop offset="0.14" style="stop-color: #006dbe" />
              <stop offset="0.3" style="stop-color: #007cc8" />
              <stop offset="0.47" style="stop-color: #0094d8" />
              <stop offset="0.64" style="stop-color: #00b4ed" />
              <stop offset="1" style="stop-color: #6fc2f5" />
            </linearGradient>
            <polygon
              class="st18"
              points="104.5,172.9 101.6,181.1 98.6,172.9 95.7,172.9 100.5,185.5 102.6,185.5 107.5,172.9 	"
            />

            <linearGradient
              id="SVGID_20_"
              gradientUnits="userSpaceOnUse"
              x1="114.135"
              y1="17.8865"
              x2="114.135"
              y2="5.3065"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #0068bb" />
              <stop offset="0.14" style="stop-color: #006dbe" />
              <stop offset="0.3" style="stop-color: #007cc8" />
              <stop offset="0.47" style="stop-color: #0094d8" />
              <stop offset="0.64" style="stop-color: #00b4ed" />
              <stop offset="1" style="stop-color: #6fc2f5" />
            </linearGradient>
            <polygon
              class="st19"
              points="109.3,172.9 109.3,185.5 119,185.5 119,183.3 112.2,183.3 112.2,180.2 119,180.2 119,178 112.2,178 
            112.2,175.1 119,175.1 119,172.9 	"
            />

            <linearGradient
              id="SVGID_21_"
              gradientUnits="userSpaceOnUse"
              x1="127.35"
              y1="17.8865"
              x2="127.35"
              y2="5.3065"
              gradientTransform="matrix(1 0 0 -1 0 190.7765)"
            >
              <stop offset="0" style="stop-color: #0068bb" />
              <stop offset="0.14" style="stop-color: #006dbe" />
              <stop offset="0.3" style="stop-color: #007cc8" />
              <stop offset="0.47" style="stop-color: #0094d8" />
              <stop offset="0.64" style="stop-color: #00b4ed" />
              <stop offset="1" style="stop-color: #6fc2f5" />
            </linearGradient>
            <path
              class="st20"
              d="M124.7,175.1h2.7c1.3,0,2.1,0.7,2.1,1.7s-0.8,1.7-2.1,1.7h-2.7L124.7,175.1z M121.8,172.9v12.6h2.9v-5h2.1
            l2.9,5h3.3l-3.3-5.4c1.5-0.4,2.7-1.7,2.7-3.3c0-2.1-1.8-3.9-4.8-3.9H121.8z"
            />
          </g>
        </svg>
      </div>
      <div class="main-header-menu">
        <router-link
          class="menu-menu"
          :class="{ current: path.indexOf(menu.link.paths) > -1 }"
          v-for="menu in menuList"
          v-html="menu.text"
          :key="menu.text"
          :to="menu.link"
        ></router-link>
      </div>
    </div>
  </div>
</template>
<script>
const menuList = [
  {
    text: "HOME",
    link: { name: "Index", paths: "index" },
    current: false,
  },
  {
    text: "OUR STRENGTH",
    link: { name: "OurStrength", paths: "ourStrength" },
    current: false,
  },
  {
    text: "PROJECTS",
    link: { name: "Projects", paths: "projects" },
    current: false,
  },
  {
    text: "HOMING Series",
    link: { name: "HomingSeries", paths: "homingSeries" },
    current: false,
  },
  {
    text: "CONTACT US",
    link: { name: "ContactUs", paths: "contactUs" },
    current: false,
  },
];
export default {
  name: "MainHeader",

  created() {
    this.path = this.$route.path;
  },
  data() {
    return {
      menuList: menuList,
      // 路由path
      path: this.$route.path,
    };
  },
  methods: {
    nextIndex() {
      this.$router.push({ name: "index" });
    },
  },
  watch: {
    $route(to, from) {
      this.current = this.path.indexOf(this.menu.link.paths) > -1;
    },
  },
};
</script>
<style rel="stylesheet/less" type="text/less" lang="less" scoped>
.header {
  clear: both;
  width: 100%;
  z-index: 999;
  position: relative;
  transition: all 0.2s ease-in-out 0s;
  padding: 25px 0;
  background: #fff;
  .container {
    position: relative;
    width: 1230px;
    margin: 0 auto;
    padding: 0px 25px;
    max-width: 100%;
    display: flex;
    align-items: center;
    .site-branding {
      margin: 0;
      text-align: center;
      margin-bottom: 0px;
      cursor: pointer;
      .top_log {
        width: 57px;
      }
      svg {
        .st0 {
          fill: url(#SVGID_1_);
        }
        .st1 {
          fill: url(#SVGID_2_);
        }
        .st2 {
          fill: url(#SVGID_3_);
        }
        .st3 {
          fill: url(#SVGID_4_);
        }
        .st4 {
          fill: url(#SVGID_5_);
        }
        .st5 {
          fill: url(#SVGID_6_);
        }
        .st6 {
          fill: url(#SVGID_7_);
        }
        .st7 {
          fill: url(#SVGID_8_);
        }
        .st8 {
          fill: url(#SVGID_9_);
        }
        .st9 {
          fill: url(#SVGID_10_);
        }
        .st10 {
          fill: url(#SVGID_11_);
        }
        .st11 {
          fill: url(#SVGID_12_);
        }
        .st12 {
          fill: url(#SVGID_13_);
        }
        .st13 {
          fill: url(#SVGID_14_);
        }
        .st14 {
          fill: url(#SVGID_15_);
        }
        .st15 {
          fill: url(#SVGID_16_);
        }
        .st16 {
          fill: url(#SVGID_17_);
        }
        .st17 {
          fill: url(#SVGID_18_);
        }
        .st18 {
          fill: url(#SVGID_19_);
        }
        .st19 {
          fill: url(#SVGID_20_);
        }
        .st20 {
          fill: url(#SVGID_21_);
        }
      }
    }
    .main-header-menu {
      margin-left: auto;
      .menu-menu {
        font-family: Montserrat-Regular;
        color: #222222;
        font-weight: 600;
        font-size: 14px;
        margin: 0 20px 0 0;
        &:hover,
        &.current {
          color: #0095dd;
        }
      }
    }
    .header-right {
      margin-top: 15px;
      margin-left: 20px;
      .quick-link-buttons .cart-button i {
        margin-right: 10px;
      }
      .quick-link-buttons {
        position: relative;
      }
      .quick-link-buttons .cart-button > span {
        min-width: 15px;
        min-height: 15px;
        background-color: #fff;
        border-radius: 100%;
        font-size: 11px;
        padding: 1px 0px;
        line-height: 1.2;
        position: absolute;
        top: -12px;
        background: #f1f0f0;
        text-align: center;
        right: 0;
      }
    }
    .header-search {
      position: relative;
      margin-left: 15px;
    }
    .search-box-wrap {
      background: #ffffff;
      display: none;
      position: absolute;
      right: 0;
      top: 64px;
      padding: 25px 30px 25px;
      z-index: 9991;
      box-shadow: 0 0 6px #00000036;
    }
    .header-search a.search-icon {
      padding: 16px 0 0;
      display: block;
      font-size: 13px;
      color: #fff;
    }
  }
}
</style>
